import React from 'react'
import { hydrate } from 'react-dom'
import { CoreApp } from './CoreApp'
import { AppContainer } from 'react-hot-loader'
import 'lib/hotnessNotifier'
import tippy from 'tippy.js'
import { tippyDefaults } from 'lib/tippyDefaults'
import { getCurrentUser } from 'lib/utils'
import { setMomentLocale } from 'lib/localization'
if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill-locales')
}

// Do some global things before booting the app:

// Attach user account level to this google analytics session so that
// we can facet audience segments by account level in reports.
//
// Can be managed at Google Analytics > Admin > Property Settings > Custom Dimensions
if (window.ga) {
  // -1 means unauthenticated
  const currentUserAccountLevel = getCurrentUser().accountLevel
  const analyticsAccountLevel = Number.isFinite(currentUserAccountLevel)
    ? currentUserAccountLevel
    : -1
  window.ga('set', 'dimension1', analyticsAccountLevel)
}

// tippy root needs to be document.body, not #rwgps-ui-core, in order to
// apply to modals that are rendered in portals.
//
// note that this has potential performance implications, as every
// mouseover event that bubbles will now be used by tippy to check if the element
// needs a tooltip
tippy(document.body, {
  ...tippyDefaults,
  target: '[data-tip]'
})

setMomentLocale()

// boot up the Core react app
const root = document.getElementById('rwgps-ui-core')

if (process.env.NODE_ENV === 'production') {
  hydrate(<CoreApp />, root)
} else {
  hydrate(
    <AppContainer>
      <CoreApp />
    </AppContainer>,
    root)

  if (module.hot) {
    module.hot.accept('./CoreApp', () => {
      const NextApp = require('./CoreApp').CoreApp
      hydrate(
        <AppContainer>
          <NextApp />
        </AppContainer>,
        root
      )
    })
  }
}
